export function branch(state) {
  return state.branch;
}
